import { render, staticRenderFns } from "./AdsType29.vue?vue&type=template&id=6065eee4&scoped=true&"
import script from "./AdsType29.vue?vue&type=script&lang=js&"
export * from "./AdsType29.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./AdsType29.vue?vue&type=style&index=0&id=6065eee4&prod&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6065eee4",
  null
  ,true
)

export default component.exports